export default __webpack_public_path__ + "static/media/userImg.b45e7fbc.svg";